(function () {
	document.addEventListener("shopify:section:load", function () {
		const slider = new Swiper(".js-media-list", getSliderSettings);

		const subSlider = new Swiper(
			".js-media-sublist",
			getSubSliderProductSettings
		);

		setTimeout(function () {
			slider.update();
			subSlider.update();
		}, 200);
	});

  let swiperProductImg;

	const addClasses = () => {
		const slides = document.querySelectorAll(".product__media-item");
		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});
	};

	const initSlider = () => {

		swiperProductImg = new Swiper('.product__media-desktop .js-one', {
			slidesPerView: 1,
			spaceBetween: 12,
			loop: true
		});
	};

	const isMobile = () => {
		return window.innerWidth <= 768; // Adjust the width threshold as needed
	};

	const initializeOnMobile = () => {
		if (isMobile()) {
			// addClasses(); // Uncomment if you need to add classes dynamically
			initSlider();
		}
	};

	initializeOnMobile();

	document.addEventListener("shopify:section:load", function () {
		initializeOnMobile();
	});

	window.addEventListener('resize', function() {
		initializeOnMobile();
	});
})();

let attached = false;

let imageContainer = document.querySelector("#image");

const followMouse = (event) => {
	imageContainer.style.left = event.pageX + "px";
	imageContainer.style.top = event.pageY + "px";
};

function showImage() {
	if (!attached) {
		attached = true;
		imageContainer.style.display = "block";
		document.addEventListener("pointermove", followMouse);
	}
}

function hideImage() {
	attached = false;
	imageContainer.style.display = "";
	document.removeEventListener("pointermove", followMouse);
}
